<template>
  <SplNuxtLink
    is-external
    no-lang
    :to="url"
    :is-disabled="linkDisabled || hasLocationWithNoLanding"
  >
    <div class="search-result">
      <div class="search-result__icon">
        <MapMarkerIcon
          v-if="location.type == 'community'"
          variant="dark"
          :size="20"
        />
        <LocationIcon
          v-else
          variant="dark"
          :size="20"
        />
      </div>
      <div class="search-result__labels">
        <p class="search-result__labels__header">
          {{ location.label }}, <DynLang
            :by-key="location.typeLabel"
            capitalize-first
          />
        </p>
        <p>
          <span v-if="shouldShowLocationParent">
            {{ parentLabel }},
          </span>
          <span>{{ countryLabel }}</span>
        </p>
      </div>
    </div>
  </SplNuxtLink>
</template>

<script lang="ts">
import SplNuxtLink from '../../shared/SplNuxtLink.vue'

import LocationIcon from '../../shared/icons/Location.icon.vue'
import MapMarkerIcon from '../../shared/icons/MapMarker.icon.vue'

import { Location } from '~/core/ts/entity/Location'

export default defineNuxtComponent({
  components: {
    SplNuxtLink,
    LocationIcon,
    MapMarkerIcon,
  },
  props: {
    location: {
      type: Object as PropType<Location>,
      required: true
    },
    locationParent: {
      type: Object as PropType<Location | null>,
      required: false,
    },
    locationCountry: {
      type: Object as PropType<Location | null>,
      required: false,
    },
    linkDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const url = computed(() => {
      return props.location.urls.spas.url
    })

    const hasLocationWithNoLanding = computed(() => !props.location.urls.spas.url)

    const shouldShowLocationParent = computed(() => {
      if (!props.locationParent) {
        return false
      }

      if (props.locationParent.type === 'country') {
        return false
      }

      return true
    })

    const parentLabel = computed(() => {
      if (!props.locationParent) {
        return ''
      }

      return props.locationParent.label
    })

    const countryLabel = computed(() => {
      if (!props.locationCountry) {
        return 'España'
      }

      if (props.locationCountry.label === 'Spain') {
        return 'España'
      }

      return props.locationCountry.label
    })

    return {
      url,
      hasLocationWithNoLanding,

      shouldShowLocationParent,

      parentLabel,
      countryLabel,
    }
  }
})
</script>

<style lang="scss" scoped>
@import url('./search-result.scss');
</style>
